import React from 'react'
import {
  Label,
  Input,
  FormFeedback,
  FormGroup,
  InputProps,
} from 'reactstrap'
import styled from 'styled-components'

const GdprHolder = styled(FormGroup)`
  text-align: left;
  font-size: 12px;
  margin-bottom: 1rem;
`

type AcceptanceProps = InputProps & {
  feedback?: string,
}

export const GdprAcceptance: React.FC<AcceptanceProps> = ({ feedback, ...props }) => {
  return (
    <GdprHolder check>
      <Label check for={props.name}>
        <Input type="checkbox" {...props} />
        I consent to my data being processed as defined in the <a href="https://birdlevel.com/privacy/" rel="noopener noreferrer" target="_blank">full privacy policy</a>.
        <FormFeedback>{feedback}</FormFeedback>
      </Label>
    </GdprHolder>
  )
}
